import React, { useState, useEffect } from 'react'
import { withTranslation } from 'react-i18next'
import styles from './ContactInformation.module.scss'
import { useSelector, useDispatch } from 'react-redux'
import { addressUpdateAction } from 'redux/actions'

const Address = ({ t, addressUpdateError, setAddressUpdated, addressUpdateValid, setAddressUpdateValid }) => {
  const dispatch = useDispatch()
  const [selectedOption, setSelectedOption] = useState('')
  const { addressUpdate } = useSelector((state) => state.app)

  useEffect(() => {
    setSelectedOption(addressUpdate === true ? 'yes' : addressUpdate === false ? 'no' : '')
    setAddressUpdated(addressUpdate)
  }, [addressUpdate])

  const onOptionChange = (e) => {
    let option = e.currentTarget.value
    let addressUpdatedOp = option === 'yes' ? true : false
    setSelectedOption(option)
    setAddressUpdateValid(true)
    setAddressUpdated(addressUpdatedOp)
    dispatch(addressUpdateAction(addressUpdatedOp))
  }

  return (
    <div className={styles['fields_margin']}>
      <div className={addressUpdateValid === false && selectedOption === '' && 'form-group ns-form-group-message-error'}>
        <label className="control-label" htmlFor="PaymentAmount">
          <strong>{t('address_update_question.have_you_recently')}</strong>
        </label>
        <div className="help-field">{t('address_update_question.in_the_last_two')}</div>
        {addressUpdateValid === false && (
          <div className="ns-form-error-container has-error error-msg-align">
            <i className={['fa fa-exclamation-circle', styles['icon_margin_left']].join(' ')} aria-hidden="true"></i>
            <div className="help-block-focused">{t(addressUpdateError)}</div>
          </div>
        )}
        <div>
          <div className="ns-radios__item">
            <input
              className="ns-radios__input"
              type="radio"
              name="addressUpdateYes"
              value="yes"
              checked={selectedOption === 'yes'}
              onChange={onOptionChange}
            />
            <label className="ns-label ns-radios__label">
              <span className="ns-label-span">
                <b>{t('address_update_question.yes')}</b>
              </span>
            </label>
          </div>
          <div className="ns-radios__item">
            <input
              className="ns-radios__input"
              type="radio"
              name="addressUpdateNo"
              value="no"
              checked={selectedOption === 'no'}
              onChange={onOptionChange}
            />
            <label className="ns-label ns-radios__label">
              <span className="ns-label-span">
                <b>{t('address_update_question.no')}</b>
              </span>
            </label>
          </div>
        </div>
      </div>
    </div>
  )
}

export default withTranslation('common')(Address)
